import { Reducer, AnyAction } from 'redux';
import { AdministrationMessagesListState } from './types-store';
import {
  ACTION, RequestMessages, ReceiveMessages, FailMessages,
  RequestUpdateMessage, ReceiveUpdateMessage, FailUpdateMessage,
  ReceiveDeleteMessage,
  UpdateQuery, UpdateIncludeInactive
} from './action-types';

export const INITIAL_STATE: AdministrationMessagesListState = {
  query: '',
  includeInactive: true,
  fetching: false,
  numberOfResults: 0,
  messages: undefined,
  updatingMessages: []
};

const reducers: { [indexer: string]: Reducer<AdministrationMessagesListState> } = {

  [ACTION.REQUEST_MESSAGES]: (state: AdministrationMessagesListState,
    action: RequestMessages): AdministrationMessagesListState => {

    return {
      ...state,
      fetching: true,
      messages: action.clearList ? undefined : state.messages
    };
  },

  [ACTION.RECEIVE_MESSAGES]: (state: AdministrationMessagesListState,
    action: ReceiveMessages): AdministrationMessagesListState => {

    return state.fetching ?
      {
        ...state,
        fetching: false,
        numberOfResults: action.numberOfResults,
        messages: action.clearList ?
          action.messages
          : [
            ...(state.messages || []),
            ...action.messages
          ]
      } : state;
  },

  [ACTION.FAIL_MESSAGES]: (state: AdministrationMessagesListState,
    action: FailMessages): AdministrationMessagesListState => {

    return state.fetching
      ? {
        ...state,
        fetching: false
      }
      : state;
  },

  [ACTION.REQUEST_UPDATE_MESSAGE]: (state: AdministrationMessagesListState,
    action: RequestUpdateMessage): AdministrationMessagesListState => {

    return !state.updatingMessages || !state.updatingMessages.includes(action.id)
      ? {
        ...state,
        updatingMessages: [
          ...(state.updatingMessages || []),
          action.id
        ]
      }
      : state;
  },

  [ACTION.RECEIVE_UPDATE_MESSAGE]: (state: AdministrationMessagesListState,
    action: ReceiveUpdateMessage): AdministrationMessagesListState => {

    const messages = (state.messages || [])
      .map(message => message.id === action.id
        ? {
          ...message,
          ...(!!action.message && action.message)
        }
        : message)
      .filter(message => action.includeInactive || message.active);

    const numberOfResults = action.includeInactive ? state.numberOfResults : messages.length;

    return {
      ...state,
      messages,
      numberOfResults,
      updatingMessages: (state.updatingMessages || []).filter(id => id !== action.id)
    };
  },

  [ACTION.FAIL_UPDATE_MESSAGE]: (state: AdministrationMessagesListState,
    action: FailUpdateMessage): AdministrationMessagesListState => {

    return state.updatingMessages && state.updatingMessages.includes(action.id)
      ? {
        ...state,
        updatingMessages: state.updatingMessages.filter(id => id !== action.id)
      }
      : state;
  },

  [ACTION.RECEIVE_DELETE_MESSAGE]: (state: AdministrationMessagesListState,
    action: ReceiveDeleteMessage): AdministrationMessagesListState => {

    return {
      ...state,
      messages: (state.messages || [])
        .filter(message => message.id !== action.id),
      numberOfResults: state.numberOfResults > 0 ? state.numberOfResults - 1 : 0,
      updatingMessages: state.updatingMessages.filter(id => id !== action.id)
    };
  },

  [ACTION.UPDATE_QUERY]: (state: AdministrationMessagesListState,
    action: UpdateQuery): AdministrationMessagesListState => {

    return state.query !== action.query ? {
      ...state,
      query: action.query
    } : state;
  },

  [ACTION.UPDATE_INCLUDE_INACTIVE]: (state: AdministrationMessagesListState,
    action: UpdateIncludeInactive): AdministrationMessagesListState => {

    return state.includeInactive !== action.includeInactive ? {
      ...state,
      includeInactive: action.includeInactive
    } : state;
  }
};

export const reducer: Reducer<AdministrationMessagesListState> = (
  state: AdministrationMessagesListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
